import { useState } from 'react';
import { faqData } from '@/mocks/categories';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-3xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Häufig gestellte Fragen zum OOPBuy Spreadsheet
          </h2>
        </div>

        <div className="space-y-0">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="border-b border-background-300/60 last:border-b-0"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-start gap-6 py-5 text-left cursor-pointer group"
              >
                <span className="font-heading text-2xl text-foreground-300 font-bold min-w-[2rem]">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="flex-1 text-base md:text-lg font-semibold text-foreground-800 group-hover:text-foreground-900 transition-colors duration-200">
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center mt-0.5">
                  <i
                    className={`ri-add-line text-xl text-foreground-400 transition-transform duration-300 ${
                      openIdx === idx ? 'rotate-45' : ''
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-[400ms] ease-in-out ${
                  openIdx === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-base leading-relaxed pl-[3.5rem] pr-8">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}